import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 490.667 490.667' fill={fillColor} className={className}>
      <path d='M245.333,0C110.059,0,0,110.059,0,245.333s110.059,245.333,245.333,245.333s245.333-110.059,245.333-245.333 S380.608,0,245.333,0z M245.333,448c-111.744,0-202.667-90.923-202.667-202.667S133.589,42.667,245.333,42.667 S448,133.589,448,245.333S357.077,448,245.333,448z' />
      <path d='M359.552,131.136c-3.093-3.115-7.765-4.011-11.755-2.261l-149.333,64c-2.517,1.067-4.523,3.093-5.611,5.611l-64,149.333 c-1.728,4.011-0.832,8.661,2.261,11.755c2.048,2.005,4.779,3.093,7.552,3.093c1.408,0,2.837-0.299,4.203-0.853l149.333-64 c2.517-1.088,4.523-3.093,5.611-5.611l64-149.333C363.52,138.859,362.624,134.208,359.552,131.136z M245.333,266.667 c-11.755,0-21.333-9.579-21.333-21.333c0-11.755,9.579-21.333,21.333-21.333c11.755,0,21.333,9.579,21.333,21.333 C266.667,257.088,257.088,266.667,245.333,266.667z' />
    </svg>
  );
});

export default React.memo(Icon);
